module.exports = __webpack_public_path__ + "static/assets/b8cc62dee2cc8a56df12748b96943dbc.gif";